import { executeHttpRequest } from '../infra/HttpClient';
import KeywordSuggestionsApi from '../../react/api/KeywordSuggestionsApi';
import { isEmpty } from 'lodash';

export function getSuggestedKeywords(text) {
  return isEmpty(text) ? Promise.resolve([]) : executeHttpRequest(KeywordSuggestionsApi.getSuggestedKeywords(text));
}
